import ChangeAddressScreen from 'features/personalDetails/screens/ChangeAddress/ChangeAddressScreen';
import React from 'react';

export default function ChangeAddressPage() {
  return <ChangeAddressScreen screenType="mailingAddressScreen" />;
}
